import ApiService from '@/services/ApiService';

export default class FindAddressesForPostcode {
    apiService;

    baseUrl = `https://ws.postcoder.com/pcw/${process.env.VUE_APP_POSTCODER_API_KEY}/address/`;

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(this.baseUrl);
    }

    handle(postcode, countryIso = 'de') {
        return this.apiService
            .get(`${countryIso}/${postcode}`, {
                params: {
                    lines: 2,
                },
            });
    }
}
